(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pa-lookbook"] && !Shopify.designMode) return;
  try {
    
(function() {
  var entries = document.querySelectorAll('[data-pa-lookbook-entry]');
  var cta = document.querySelector('[data-scroll-cta]');

  if (entries.length === 0) return;

  // Scroll-triggered reveal using IntersectionObserver
  var observer = new IntersectionObserver(function(ents) {
    ents.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
      }
    });
  }, {
    threshold: 0.15,
    rootMargin: '0px 0px -50px 0px'
  });

  entries.forEach(function(el) { observer.observe(el); });

  // Scroll CTA — smooth scroll to first entry
  if (cta) {
    cta.addEventListener('click', function() {
      if (entries[0]) {
        entries[0].scrollIntoView({ behavior: 'smooth' });
      }
    });
  }

  // Build navigation dots
  var dotsContainer = document.querySelector('[data-lookbook-dots]');
  if (dotsContainer && entries.length > 0) {
    entries.forEach(function(_, i) {
      var dot = document.createElement('button');
      dot.className = 'pa-lookbook__dot';
      dot.setAttribute('data-dot-index', i);
      dot.setAttribute('aria-label', 'Go to Look ' + (i + 1));
      dotsContainer.appendChild(dot);
    });

    var dots = dotsContainer.querySelectorAll('.pa-lookbook__dot');

    // Track active entry
    var dotObserver = new IntersectionObserver(function(ents) {
      ents.forEach(function(entry) {
        var idx = Array.from(entries).indexOf(entry.target);
        if (entry.isIntersecting) {
          dots.forEach(function(d) { d.classList.remove('is-active'); });
          if (dots[idx]) dots[idx].classList.add('is-active');
        }
      });
    }, { threshold: 0.5 });

    entries.forEach(function(el) { dotObserver.observe(el); });

    // Clickable dots
    dots.forEach(function(dot, i) {
      dot.addEventListener('click', function() {
        entries[i].scrollIntoView({ behavior: 'smooth' });
      });
    });
  }

  // Dim header while in lookbook
  var header = document.querySelector('.pa-header');
  var lookbookSection = document.querySelector('[data-pa-lookbook]');
  if (header && lookbookSection) {
    var scrollTimeout;
    window.addEventListener('scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
        var rect = lookbookSection.getBoundingClientRect();
        if (rect.top <= 0 && rect.bottom >= window.innerHeight) {
          document.body.classList.add('pa-lookbook-active');
        } else {
          document.body.classList.remove('pa-lookbook-active');
        }
      }, 50);
    }, { passive: true });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
